import { observer } from "mobx-react";
import QmsDashboardPage from "./QmsDashboardPage"
import { Component } from "react";
import qmsDashboardPageStore from "./qms-dashboard-page-store";
import PasaCampaign from "../components/pasa-campaign/PasaCampaign";

const QmsMainDashboard = observer(
    class QmsMainDashboard extends Component {

        render(

        ) {
            return (

                <>
                    {qmsDashboardPageStore.selectedScreen === "Quotes & Applications [10]" ?

                        <QmsDashboardPage {...this.props} />
                        :
                        <PasaCampaign />
                    }


                </>
            )
        }
    }
)
export default QmsMainDashboard;